import { useRecoilTask } from 'recoil-toolkit';

import { closeDrawerTask, showDrawerTask } from './tasks';

export const useShowDrawer = () => useRecoilTask(showDrawerTask, []);
export const useCloseDrawer = () => useRecoilTask(closeDrawerTask, []);
